import React from "react"

const UnionLink = () => {
  return <a href="https://www.aizu-kouiki.jp/" target="_blank" className="linkarrow linkcircle">会津若松地方<br />広域市町村圏整備組合HP</a>
}

export default UnionLink